import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '../../app.config';
import { PhBhpNotificationService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  clientData: any;
  isDeskTop = true;
  isUserName = environment.isUserName;
  constructor(private router: Router, public config: AppConfig, private notification: PhBhpNotificationService) { }

  ngOnInit() {
    this.clientData = this.config.clientData;
  }
  notificationData(userData) {
    this.notification.requestPermission(userData);
    //this.notification.receiveMessage();
  }
  onChildData(event: any) {
   
    switch (event.key) {
      case 'dashboard':
      case 'signin':
      case 'forgetpassword':
        this.router.navigate([event.key]);
        break;
      case 'success':
        this.config.userData = event.val.user;
        this.config.institutions = event.val.institutions;
        // bug fix for role name, unify type of property
        if(typeof this.config.userData.roleName === 'string'){
          this.config.userData.roleName = JSON.parse(this.config.userData.roleName);
        }
        this.config.campaigns = event.val.campaigns;
        this.notificationData(this.config.userData);
        this.router.navigate(['dashboard']);
        break;
      case 'FirstTimeLogin':
        this.config.userData = event.val.user;
        this.config.institutions = event.val.institutions;
        try {
          this.config.userData.roleName = JSON.parse(this.config.userData.roleName);
        } catch (e) {
            console.warn('roleName is already parsed:', e.message);
        }
        this.router.navigate(['changePassword']);
        break;
    }
  }
}
